module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-item dash-contact col-md-4 form-horizontal"
  }, [_c('contact-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listDisp),
      expression: "listDisp"
    }],
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.app.nowLang,
      "getContact": _vm.getContact,
      "searchParams": _vm.searchParams,
      "receivedContactsInfiniteLoading": _vm.receivedContactsInfiniteLoading,
      "toggle": _vm.toggle,
      "receivedMultiSelect": _vm.receivedMultiSelect,
      "pcDisp": _vm.pcDisp,
      "postContactFavorite": _vm.postContactFavorite,
      "triggerContactInfiniteBool": _vm.triggerContactInfiniteBool,
      "triggerResetBool": _vm.triggerResetBool,
      "baseURL": _vm.baseURL
    },
    on: {
      "disableTriggerResetBool": function($event) {
        _vm.triggerResetBool = false
      }
    }
  }), _vm._v(" "), _c('contact-search', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchDisp),
      expression: "searchDisp"
    }],
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "fullname": _vm.fullname,
      "company": _vm.company,
      "position": _vm.position,
      "pcDisp": _vm.pcDisp
    },
    on: {
      "enableTriggerResetBool": function($event) {
        _vm.triggerResetBool = true
      }
    },
    model: {
      value: (_vm.searchParams),
      callback: function($$v) {
        _vm.searchParams = $$v
      },
      expression: "searchParams"
    }
  }), _vm._v(" "), _c('contact-detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.app.nowLang,
      "contact": _vm.contact,
      "toggle": _vm.toggle,
      "pcDisp": _vm.pcDisp,
      "postContactFavorite": _vm.postContactFavorite,
      "baseURL": _vm.baseURL
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-287b12a7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/component.vue
// module id = 3643
// module chunks = 1